<template>
	<div class="tb-tag-list">
		<md-chip v-for="(tag, index) in value" :key="getTagValue(tag)"
				 @md-delete="onDelete(index)"
				 :md-deletable="!disabled"
				 class="default_radius"
				 :class="getTagClass(tag)"
		>
			<span>{{ getTagDisplayValue(tag) }}</span>
		</md-chip>
	</div>
</template>

<script>
export default {
	props: {
		value: { type: Array, default: [] }, // List of tags to display
		tagValueField: { type: String, default: null },  // Field of the tag object to be used as internal value. Whole object is used if this is null
		tagDisplayField: { type: String, default: null }, // Field of the tag object to be used as display value. Whole object is used if this is null
		tagDisplayGetter: { type: Function, default: null }, // Getter function to assemble the tag display value
		tagClass: { type: String, default: null }, // General class applied to all tags
		tagClassField: { type: String, default: null }, // Field of the tag object to use as tag class. Overrides the general tag class
		disabled: { type: Boolean, default: false }, // When disabled, tags cannot be deleted
	},
	methods: {
		onDelete(index) {
			let removedTag = this.value[index];
			this.value.splice(index, 1);

			this.$emit("input", this.value);
			this.$emit("deleted", this.getTagValue(removedTag));
		},
		getTagValue(tag) {
			return this.tagValueField ? tag[this.tagValueField] : tag;
		},
		getTagDisplayValue(tag) {
			if (this.tagDisplayGetter) {
				return String(this.tagDisplayGetter(tag));
			} else {
				return String(this.tagDisplayField ? tag[this.tagDisplayField] : tag);
			}
		},
		getTagClass(tag) {
			return this.tagClassField && tag[this.tagClassField] ? tag[this.tagClassField] : (this.tagClass || "");
		}
	}
};
</script>

<style lang="scss" scoped>
.tb-tag-list {
	overflow: auto;

	.md-chip {
		height: fit-content;
		white-space: break-spaces;
		padding-top: 5px;
		padding-bottom: 5px;
	}
}
</style>